import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '#src/atoms/buttons/Button/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyM, HeadlineL } from '#src/atoms/typography/index.tsx';

import { useAccountVerification } from '../AccountVerificationContext.tsx';
import { BottomActions } from '../shared/BottomActions.tsx';
import { UserAvatarWithFlag } from '../shared/UserAvatarWithFlag.tsx';
import { SkipVerificationDialog } from './SkipVerificationDialog.tsx';

const Root = styled(Vertical).attrs({ gap: 4 })`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const Content = styled(Vertical)`
  flex: 1;
  align-items: center;
  padding: var(--quadruple-unit) var(--double-unit) 0;
  gap: var(--double-unit);
`;

const TextContent = styled(Vertical)`
  width: 100%;
  align-items: center;
  text-align: center;
  gap: 0;
`;

const Title = styled(HeadlineL)`
  color: var(--c-white);
  width: 100%;
  margin-bottom: var(--unit);
`;

const Description = styled(BodyM)`
  color: var(--c-nd-600);
  width: 100%;
`;

type Props = {
  onNext: () => void;
};

export const IdentityVerificationCTA = ({ onNext }: Props) => {
  const { onSkip } = useAccountVerification();
  const [showSkipDialog, setShowSkipDialog] = useState(false);

  return (
    <Root>
      {!!showSkipDialog && (
        <SkipVerificationDialog
          onGoBack={() => setShowSkipDialog(false)}
          onSkip={onSkip}
        />
      )}
      <Content>
        <UserAvatarWithFlag />
        <TextContent>
          <Title bold>
            <FormattedMessage defaultMessage="Verify your identity" />
          </Title>
          <Description>
            <FormattedMessage defaultMessage="To finalize the verification of your account we need to verify your identity: it's simple, secure and generally takes a few minutes. Rewards will only be awarded after your identity has been verified." />
          </Description>
        </TextContent>
      </Content>
      <BottomActions
        primaryAction={
          <Button size="medium" color="primary" onClick={onNext} fullWidth>
            <FormattedMessage defaultMessage="Verify my identity" />
          </Button>
        }
        secondaryAction={
          <Button
            size="medium"
            color="transparent"
            onClick={() => setShowSkipDialog(true)}
            fullWidth
          >
            <FormattedMessage defaultMessage="Later" />
          </Button>
        }
      />
    </Root>
  );
};
